/**
 * @const primaryBlue - Allison Transmission theme blue
 */
export const primaryBlue: string = 'rgba(19, 94, 171, 1)';
/**
 * @const darkBlue darker shade of blue
 */
export const darkBlue: string = 'rgba(33, 72, 113, 1)';
/**
 * @const secondaryBlue - Alternative lighter shade of blue for contrasting sections of content
 */
export const secondaryBlue: string = 'rgba(62, 98, 137, 1)';
/**
 * @const lightBlue - Light blue that pairs with a dark/black text color
 */
export const lightBlue: string = 'rgba(33, 72, 113, 0.5)';

/**
 * @const primaryYellow Allison Transmission theme yellow
 */
export const primaryYellow: string = 'rgba(233, 181, 58, 1)';
/**
 * @const lightYellow Light yellow that pairs with a dark/black text color
 */
export const lightYellow: string = 'rgba(236, 177, 16, 0.5)';

/**
 * @const primaryRed Allison Transmission theme red
 */
export const primaryRed: string = 'rgba(237, 39, 36, 1)';
/**
 * @const darkRed darker red variant
 */
export const darkRed: string = 'rgba(150, 37, 55, 1)';
/**
 * @const lightRed Light red that pairs with a dark/black text color
 */
export const lightRed: string = 'rgba(150, 37, 55, 0.5)';

/**
 * @const primaryText Slightly grey text color
 */
export const primaryText: string = 'rgba(238, 238, 238, 1)';
/**
 * @const darkText Dark text color
 */
export const darkText: string = 'rgba(11, 11, 11, 1)';
/**
 * @const darkGrey Dark grey color
 */
export const darkGrey: string = 'rgba(88, 89, 91, 1)';

/**
 * @const background Core background color
 */
export const background: string = 'rgba(245, 246, 250, 1)';
/**
 * @const darkerBackground Slightly darker than backgroundColor, useful for filling placeholder sections
 */
export const darkerBackground: string = 'rgba(236, 237, 238, 1)';
/**
 * @const border Greyish blue for unfocused text field borders
 */
export const border: string = 'rgba(111, 110, 141, 1)';
/**
 * @const successGreen Greyish blue for unfocused text field borders
 */
export const successGreen: string = 'rgba(19, 171, 96, 1)';
